// Portfel — UI entry point.
import "./app.css";
import { mount } from "svelte";
import App from "./App.svelte";

mount(App, { target: document.body });
